import { MessageReadStatus, type MessageReadStatusProps } from '@halo/ui-chat-react';
import { useSessionContentsContext } from '../session-parts';

export interface MsgReadStatusProps extends MessageReadStatusProps {}

export const MsgReadStatus = memo(function MsgReadStatus(props: MsgReadStatusProps) {
  const { hideMembers } = useSessionContentsContext();
  return <MessageReadStatus {...props} hideMember={hideMembers} />;
});
